import { render } from "./CardDeck.vue?vue&type=template&id=2fb6a4e4&scoped=true"
import script from "./CardDeck.vue?vue&type=script&lang=js"
export * from "./CardDeck.vue?vue&type=script&lang=js"

import "./CardDeck.vue?vue&type=style&index=0&id=2fb6a4e4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb6a4e4"]])

export default __exports__